import React from 'react';
import { X } from 'lucide-react';
import { TIMEFRAMES } from '../lib/data';

// Keeps every applied facet visible and removable directly above the queue, so
// collapsing the four dropdowns into the Filters popover never hides "what am I
// looking at". Each chip's ✕ resets just that facet; Clear all resets them.
export default function ActiveFilterBreadcrumb({
  timeframe, setTimeframe, provider, setProvider, location, setLocation,
  payer, setPayer, visitType, setVisitType, providers = [], locations = [], payers = [], clearFilters,
}) {
  const chips = [];
  if (timeframe && timeframe !== 'today') chips.push({ key: 'tf', label: TIMEFRAMES.find((t) => t.k === timeframe)?.label || timeframe, onRemove: () => setTimeframe('today') });
  if (provider !== 'all') chips.push({ key: 'prov', label: `Dr. ${providers.find((p) => p.id === provider)?.lastName || provider}`, onRemove: () => setProvider('all') });
  if (location !== 'all') chips.push({ key: 'loc', label: locations.find((l) => l.id === location)?.name || location, onRemove: () => setLocation('all') });
  if (payer !== 'all') chips.push({ key: 'pay', label: payers.find((p) => p.id === payer)?.name || payer, onRemove: () => setPayer('all') });
  if (visitType !== 'all') chips.push({ key: 'vt', label: visitType, onRemove: () => setVisitType('all') });

  if (!chips.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs text-slate-400">Filtered by</span>
      {chips.map((c) => (
        <button key={c.key} onClick={c.onRemove} className="pill pill-slate hover:bg-slate-200 transition-colors group" title={`Remove ${c.label}`}>
          {c.label}
          <X className="h-3 w-3 text-slate-400 group-hover:text-slate-600" />
        </button>
      ))}
      <button onClick={clearFilters} className="text-xs text-slate-500 hover:text-slate-800">Clear all</button>
    </div>
  );
}
